import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JobRecommendationCard = ({ job, onApply, onBookmark }) => {
  const getMatchColor = (percentage) => {
    if (percentage >= 90) return 'text-success bg-success/10';
    if (percentage >= 75) return 'text-primary bg-primary/10';
    if (percentage >= 60) return 'text-warning bg-warning/10';
    return 'text-text-secondary bg-muted';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-elevation-1 spring-transition">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <h3 className="text-lg font-semibold text-text-primary">{job?.title}</h3>
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getMatchColor(job?.matchPercentage)}`}>
              {job?.matchPercentage}% Match
            </span>
          </div>
          <div className="flex items-center space-x-4 text-sm text-text-secondary mb-3">
            <div className="flex items-center space-x-1">
              <Icon name="Building" size={16} />
              <span>{job?.company}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={16} />
              <span>{job?.location}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="DollarSign" size={16} />
              <span>{job?.salary}</span>
            </div>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onBookmark(job?.id)}
          className={job?.isBookmarked ? 'text-warning' : 'text-text-secondary'}
        >
          <Icon name={job?.isBookmarked ? "Bookmark" : "BookmarkPlus"} size={20} />
        </Button>
      </div>
      <div className="mb-4">
        <h4 className="text-sm font-medium text-text-primary mb-2">Why this matches you:</h4>
        <p className="text-sm text-text-secondary">{job?.matchReason}</p>
      </div>
      <div className="mb-4">
        <h4 className="text-sm font-medium text-text-primary mb-2">Required Skills:</h4>
        <div className="flex flex-wrap gap-2">
          {job?.requiredSkills?.map((skill, index) => (
            <span
              key={index}
              className={`px-2 py-1 rounded-full text-xs ${
                skill?.hasSkill 
                  ? 'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}
            >
              {skill?.name}
              {skill?.hasSkill && <Icon name="Check" size={12} className="inline ml-1" />}
            </span>
          ))}
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <Button
          variant="default"
          onClick={() => onApply(job?.id)}
          className="flex-1"
          iconName="ExternalLink"
          iconPosition="right"
        >
          Apply Now
        </Button>
        <Button
          variant="outline"
          onClick={() => console.log('View details', job?.id)}
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default JobRecommendationCard;